import { render } from "./accountFormText.vue?vue&type=template&id=23c2d5cc"
import script from "./accountFormText.vue?vue&type=script&lang=js"
export * from "./accountFormText.vue?vue&type=script&lang=js"
script.render = render

export default script